export function initializeTheme() {
  document.documentElement.classList.add("dark")
  document.documentElement.style.colorScheme = "dark"
}
